import React, {useState, useEffect, useRef} from 'react';
import { Link, useHistory } from 'react-router-dom';
// import socialPlayImg from 'assets/images/social-play-logo-vertical.png';
// import playIcon from 'assets/images/play-icon.png';
import upArrowIcon from 'assets/images/up-arrow-icon.png';
import { demoImages } from 'helpers/data/general';
import Styles from 'views/about/About.module.scss';
import AutoPlayCarousel from "components/controls/Slider/AutoPlayCarousel";
import {AboutPageSlider} from "components/controls/Slider/SliderResponsiveness";
import Button from "../../components/button/Button";
import Infographics from 'assets/images/Infographics.svg';
import { useScrollFadeIn } from 'hooks/useScrollFadeIn';

const About = () => {
    const history = useHistory();
    const [visible, setVisible] = useState(false);
    const [shouldLoadVideo, setShouldLoadVideo] = useState(false);
    
    // Scroll fade-in effects
    const featureFadeIn = useScrollFadeIn({ threshold: 0.2, rootMargin: '0px 0px -50px 0px' });
    const headingFadeIn = useScrollFadeIn({ threshold: 0.2, rootMargin: '0px 0px -50px 0px' });
    const videoFadeIn = useScrollFadeIn({ threshold: 0.1, rootMargin: '0px 0px -100px 0px' });
    const carouselFadeIn = useScrollFadeIn({ threshold: 0.1, rootMargin: '0px 0px -100px 0px' });
    const infographicsFadeIn = useScrollFadeIn({ threshold: 0.1, rootMargin: '0px 0px -100px 0px' });
    const buttonFadeIn = useScrollFadeIn({ threshold: 0.2, rootMargin: '0px 0px -50px 0px' });
    
    // Use the ref from scroll fade-in hook for video lazy loading
    const videoRef = videoFadeIn.elementRef as React.RefObject<HTMLDivElement>;
    
    useEffect(() => {
        const toggleVisible = () => {
            const scrolled = document.documentElement.scrollTop;
            const pageHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const halfPageHeight = pageHeight / 2;
            
            // Show button when scrolled past half the page height, hide when at top
            setVisible(scrolled > halfPageHeight && scrolled > 0);
        };
        
        window.addEventListener('scroll', toggleVisible, { passive: true });
        
        // Initial check
        toggleVisible();
        
        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('scroll', toggleVisible);
        };
    }, []);

    // Lazy load video section
    useEffect(() => {
        if (!videoRef.current) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setShouldLoadVideo(true);
                        observer.disconnect();
                    }
                });
            },
            { rootMargin: '100px' }
        );

        observer.observe(videoRef.current);
        return () => observer.disconnect();
    }, []);

    
    const handleCreateAccount = () => history.push('/registration');
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    };
  return (
    <section className={Styles.wrapper}>
        <div className={Styles.topHeader}>
            <Link to="/Login">Login</Link>
        </div>
        <div className="container">
            <p ref={featureFadeIn.elementRef} className={`${Styles.feature} ${featureFadeIn.isVisible ? Styles.scrollFadeIn : ''}`}>FEATURES</p>
            <p ref={headingFadeIn.elementRef} className={`${Styles.heading} ${headingFadeIn.isVisible ? Styles.scrollFadeIn : ''}`}>How does <span className={Styles.headingSpan}>Social Play</span> work?</p>
            <div ref={videoRef} className={`${Styles.videoSection} ${videoFadeIn.isVisible ? Styles.scrollFadeIn : ''}`}>
                {shouldLoadVideo ? (
                    <video 
                        controls={true} 
                        autoPlay={true}
                        className={Styles.video}
                        poster="https://ucb99db7d979add0f92ec97d22de.previews.dropboxusercontent.com/p/thumb/ABrl7--pShxNPo21tjjPuwfD2_Be9s4ONYIIAZhcxEtjxulC4qeAILuJ3g6cWWiGe50yYUprHVTdFohYPbumosQu9pV-3wifM0Sq0XQw_RV5ciy1iTCUYSr16vgkP3aHfLSV7BIKhFAbnKuZ2E-GKuwaMew6GClwCKOuuyktxPYn-THPQvFTGNsrgQdN-NdQH-WWRtu7SsvT_BLHbER6uID79BE3BF0F-6sMSbsexfAYCucEyAMI2_QHLH8sxZzNQM-EYApl63pOOZLywX9x2F8aQaY4OMDVtpWM9fqqkicDGK5LjACU8MT8xBa4vZhNGgqMUV8M_Uk0LVvuhbYMQisMhrEXeHqEoI1BeLUrCOFjn1V2hxcg215A6DQab9a9nYG6nsibpCUXnGPRwGn-heRVpvej9eD-ZZ75L2WUMhD7vAhfEiAiGEveG5VB2-UCK3SCSlraOApvPyIUg9QZP9hg5qATuA5I2Z3bjC8ChBj3QO0k5ww5l0kfvGz6sk__G8GAf2FgksTKEoDIAR1G-WbihNDBFb7qQptSV-fh10A9dtwtR0mnz8J2_QdhwGDBP5Gk8Jl5YW-SNYBeTbbm4DpwXW1wC6GLgYaIqxTZBryEaJNzuSyUTxY6qTr6-Xv6GgoJKLng_UrExvojM0mKaaxkP6uNURmzlTHh9nnpUSYjgVGyakSRPVvHpmQIhUJQlP-WCiqXy6xPnutP-yv229wEqNHMqlra9Kqg4ZUgQQDi_Tdxw6msAHSzjHIjxbphsvz7jTLzGY0hgUSkgig7yRSFqEG8YFoEgbFt1B1ZFmFJ-KaJpRNbZzmam1H3t2zpOFcmNrZxKnUcNRZhUJzBxZpaVWrd1JMsd1u-TirsFLrjZ1Mpoh_dV0wHbGBxYavhrjqygZl1Y-j3PYGQ1tgCNbji73B93tOq2Cz7IQEXwHxzYE-ko9E8vxjTGmcsJ0eciAoYTskdUs4HWG5ebcX_Ma6RXTZ2sgOhH_rF_MROqfr91A/p.jpeg?psid=979c5553-d5a2-447b-a8b9-266640796726&size=1024x768&size_mode=2">
                        <source src="https://www.dropbox.com/s/c9xcee48e5kzdve/Social%20Play%20720p%20Final.mp4?raw=1" type="video/mp4"/>
                    </video>
                ) : (
                    <div className={Styles.videoPlaceholder} />
                )}
            </div>
        </div>
        <div className={`${Styles.carouselWrapper} ${carouselFadeIn.isVisible ? Styles.scrollFadeIn : ''}`}>
            <div className="px-3 demo-slider">
                <AutoPlayCarousel 
                  slideToShow={1} 
                  sliderSetting={AboutPageSlider}
                  autoPlayInterval={30000}
                >
                  {demoImages.map((item: any, index) => (
                    <div className={Styles.sliderItem} key={index}>
                      <img 
                        src={item.image} 
                        className="w-100" 
                        alt={`Demo ${index + 1}`}
                      />
                    </div>
                  ))}
                </AutoPlayCarousel>
                <div className="mt-30">
                    <h5 className={`m-0 font-weight-600 text-black text-center ${Styles.sliderItemCaption}`}>Audio and Video chat with people nearby. View the <br />
                        conversation topics and join in.</h5>
                </div>
            </div>
        </div>
        <div className="container">
            <div ref={infographicsFadeIn.elementRef} className={`${Styles.learnMoreWrapper} ${infographicsFadeIn.isVisible ? Styles.scrollFadeIn : ''}`}>
                <div className={Styles.videoImage}>
                    <img 
                        src={Infographics} 
                        className="w-100" 
                        alt="Social Play Infographics"
                    />
                </div>
            </div>
        </div>
      <div className="container">
        <div
          ref={buttonFadeIn.elementRef}
          className={`${Styles.signUpMarginBLock} ${buttonFadeIn.isVisible ? Styles.scrollFadeIn : ''}`}
        >
        <Button clickHandler={handleCreateAccount} label="CREATE AN ACCOUNT NOW" />
        </div>
      </div>
        <button 
            className={`${Styles.backToTopIcon} ${visible ? Styles.visible : ''}`}
            onClick={scrollToTop}
            aria-label="Scroll to top"
            type="button"
        >
            <img src={upArrowIcon} alt="back to top" className={Styles.arrowIcon} />
        </button>
        <footer className={Styles.footerSection}>
            <div className={`${Styles.copyRightText} text-black fontFourteen`}>© 2025. All Rights Reserved.</div>
        </footer>
    </section>
  );
};

export default About;
